/* less/lib/less-node/index */ function _(require, module, exports) {
    var environment = require(160) /* ./environment */, FileManager = require(161) /* ./file-manager */, UrlFileManager = require(167) /* ./url-file-manager */, createFromEnvironment = require(193) /* ../less */, less = createFromEnvironment(environment, [new FileManager(), new UrlFileManager()]), lesscHelper = require(165) /* ./lessc-helper */, path = require('path');
    // allow people to create less with their own environment
    less.createFromEnvironment = createFromEnvironment;
    less.lesscHelper = lesscHelper;
    less.PluginLoader = require(166) /* ./plugin-loader */;
    less.fs = require(162) /* ./fs */;
    less.FileManager = FileManager;
    less.UrlFileManager = UrlFileManager;
    // Set up options
    less.options = require(173) /* ../less/default-options */();
    // provide image-size functionality
    require(163) /* ./image-size */(less.environment);
    module.exports = less;
}
